import React, { useState } from 'react'
import Select from 'UI/Select'

const NavigationSelect = ({ options, currentPage }) => {
  const [currentOption, changeOption] = useState(options.find(option => option.value === currentPage))

  return (
    <Select
      minWidth='200px'
      value={currentOption}
      options={options}
      onChange={option => {
        changeOption(option)
        window.location = option.value
      }}
    />
  )
}

export default NavigationSelect
